import {defineStore} from 'pinia';
import axios from "../plugins/axios";
import BusinessTimeBlockCollection from '@/model/TimeBlockCollection'

const EMAIL_REMINDER_POSTPONE_STORAGE_PREFIX = 'boarder-email-reminder-postponed-at:'
const DEFAULT_EMAIL_DOMAIN = '@lunchmenu.today'

function toLocalDateKey(date: Date): string {
  return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0')
  ].join('-')
}

export const usePiniaStore = defineStore('pinia', {
  state: () => ({
    profileDialogOpen: false,
    emailReminderVersion: 0,

  }),

  actions: {
    setProfileDialogOpen(isOpen: boolean): void {
      this.profileDialogOpen = isOpen

      if (!isOpen) {
        this.emailReminderVersion += 1
      }
    },

    recheckEmailReminder(): void {
      this.emailReminderVersion += 1
    },

    snoozeEmailReminderForUser(userId: number): void {
      localStorage.setItem(
        `${EMAIL_REMINDER_POSTPONE_STORAGE_PREFIX}${userId}`,
        toLocalDateKey(new Date())
      )
    },

    clearEmailReminderSnoozeForUser(userId: number): void {
      localStorage.removeItem(`${EMAIL_REMINDER_POSTPONE_STORAGE_PREFIX}${userId}`)
    },

    isEmailReminderSnoozedForUser(userId: number): boolean {
      return localStorage.getItem(`${EMAIL_REMINDER_POSTPONE_STORAGE_PREFIX}${userId}`) === toLocalDateKey(new Date())
    },

    isUsableEmail(email: string): boolean {
      const normalized = (email || '').trim().toLowerCase()
      return !!normalized && !normalized.endsWith(DEFAULT_EMAIL_DOMAIN)
    },

    /**
     * Zonam časových blokov
     *
     * Pôvodne sa nerozlišovali časové bloky podľa výdajného miesta. Teraz je situácia keď máme viaceré výdajné miesta.
     * Stravník je realisticky priradený len k jednému miestu, podľa zákazníka.
     */
    fetchTimeBlocks: async function (context: any): Promise<any> {
      const response = await axios.get('/api/time-block', {
        params: {
          'business.id': context.currentUser.business.id
        }
      })

      return BusinessTimeBlockCollection.createFromResponseList(response.data)
    },

    async fetchConfigurationGroups (payload: any): Promise<any[]> {
      const response = await axios.get(`/api/configuration-group`, {
        params: {
          'business.id': payload
        }
      })
      return response.data
    },

    async fetchCustomerQrConfiguration(payload: any): Promise<any> {

      const response = await axios.get(`/api/customer/${payload}`)
      return response.data

    },

    async fetchLastOrder(payload: any): Promise<any> {
      const response = await axios.get(`/api/food-ordering/offer-reservation/${payload}`)
      return response.data

    },

    async createNewRating(payload: any): Promise<any> {
      const response = await axios.post(`/api/rating/offer-reservation-rating`,{
        offerReservations: payload.offerReservations,
        value: payload.value,
        note: payload.note
      })
      return response.data
    },

    async fetchOfferRating(payload: any): Promise<any> {
      const response = await axios.get(`/api/rating/offer-reservation-rating?boarder.id=${payload.boarderId}&offerReservations.id=${payload.id}`)
      return response.data
    },

    async updateSelectedRating(payload: any): Promise<any> {
      const response = await axios.put(`/api/rating/offer-reservation-rating/${payload.id}`,{
        boarder: payload.boarderId,
        value: payload.value,
        note: payload.note,
        offerReservations: payload.offerReservations
      })
      return response.data
    },
  },
});
